export const config = {
  landingURL: 'https://www.ltclegalrisk.com/',
};
